<template>
	<div>
		<div class="box">
			<div class="row">
				<h2 class="match-header">Add Wizard Content</h2>
			</div>
            <div class="configuration-reference">
				<!-- Protopia Owners -->
				<div class="card-row row">
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Headline</label>
							<md-input v-model.trim="headline" @input="headline = sanitizeInput($event)" name="headline" :maxlength="80" v-validate.continues="'required|max:80|min:10'" placeholder="Add Headline"></md-input>						</md-field>
						<p class="error" v-show="errors.has('headline')">{{errors.first('headline')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Introduction</label>
							<md-textarea v-model.trim="introduction" @input="introduction = sanitizeInput($event)" name="introduction" :maxlength="250" v-validate.continues="'required|max:250|min:100'" placeholder="Add Introduction" rows="2" ></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('introduction')">{{errors.first('introduction')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Content</label>
							<md-textarea v-model.trim="content" @input="content = sanitizeInput($event)" name="content" :maxlength="2000" v-validate.continues="'required|max:2000|min:250'" placeholder="Add Content" rows="2" ></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('content')">{{errors.first('content')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Close</label>
							<md-textarea v-model.trim="close" @input="close = sanitizeInput($event)" name="close" :maxlength="250" v-validate.continues="'required|max:250|min:5'" placeholder="Add Close" rows="2" ></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('close')">{{errors.first('close')}}</p>
					</div>
				</div>

				<!-- Common save btn -->
				<div class="row">
					<div class="submitBtn">
						<md-button type="button" @click="saveOwner()" class="md-raised md-round md-accent">Save</md-button>
						<md-button type="button" @click="cancel()" class="md-raised md-round md-accent">Cancel</md-button>
					</div>
				</div>
            </div>
		</div>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from '@/utils/sanitizer';
export default {
    data() {
        return {
            fullPage: true,
            api: new API(),
            headline: "",
			introduction: "",
			content: "",
			close: ""
        }
    },
    watch: {
      $route: "loadData"
    },
    created() {
		const dict = {
			custom: {
				headline: {
					required: () => 'Please enter headline',
					min: () => 'minimum 10 characters',
					max: () => "Headline may not exceed 80 characters"
				},
				introduction: {
					required: () => 'Please enter introduction',
					min: () => 'minimum 100 characters',
					max: () => "Introduction may not exceed 250 characters"
				},
				content: {
					required: () => 'Please enter content',
					min: () => 'minimum 250 characters',
					max: () => "Content may not exceed 2000 characters"
				},
				close: {
					required: () => 'Please enter close',
					min: () => 'minimum 5 characters',
					max: () => "Close may not exceed 250 characters"
				}
			}
		};
		this.$validator.localize('en', dict);
    },
    methods: {
		sanitizeInput(event) {
            return sanitizeInput(event);
        },
        saveOwner: async function() {
			this.$validator.validateAll().then(async (result) => {
				if (result) {
                    let reqBody = {headline: this.headline, introduction: this.introduction, content: this.content, close: this.close}
					await this.api.post(`configuration/add-wizard-content`, reqBody).then(responseData => {
						if (responseData.data && responseData.data.status) {
							this.$router.push('/configuration/reference-wizard-content');
						} else {
							this.$toast.error(responseData.data.msg);
						}
					});
				}
			})
		},
		cancel: async function() {
			this.$router.push('/configuration/reference-wizard-content');
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfigurationWizardContentAdd.vue